/**
 * byrna-cart-chat-toggle.js - #1364
 *
 * Hides the Zendesk chat launcher while the cart side-drawer is open, so the
 * floating bubble never overlaps the state selector / checkout button.
 *
 * Trigger: the drawer toggles `.is-visible` on `.ajax-cart__overlay`
 *          (see z__jsAjaxCart.js showDrawer/hideDrawer). We observe that class
 *          rather than patching the core cart script.
 *
 * Action:  reports drawer state to window.byrnaChat and asks it to re-assert.
 *          It does NOT call zE directly. The previous version called
 *          zE('messenger','show') on every page load where the drawer was
 *          closed, which undid the mobile launcher suppression.
 */
(function () {
  'use strict';

  function setDrawerOpen(isOpen) {
    // CSS fallback for the window before the controller or zE is ready.
    document.documentElement.classList.toggle('byrna-cart-open', isOpen);

    if (!window.byrnaChat) return;
    if (window.byrnaChat.drawerOpen === isOpen) return;
    window.byrnaChat.drawerOpen = isOpen;
    window.byrnaChat.apply();
  }

  function watch(el) {
    if (!el) return;
    var observer = new MutationObserver(function () {
      setDrawerOpen(el.classList.contains('is-visible'));
    });
    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    // Sync once in case the drawer is already open on load.
    setDrawerOpen(el.classList.contains('is-visible'));
  }

  function init() {
    // Overlay is the most reliable signal; fall back to the drawer element.
    var target = document.querySelector('.ajax-cart__overlay')
      || document.querySelector('[data-ajax-cart-drawer]');
    watch(target);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
